export const DEFAULT_AVATAR_URL = "./images/icon_user.svg";
export { isSuperAdminOrAppSuperAdmin, isSupportOrAppSupport, isSupport, isAppSupport, isInternalDeveloper, isDeveloper, isSuperAdmin, isCompanyAdmin, getDevelopers, getInternalDevelopers, isUserFullyLoaded } from "../../middleware/Utils/ContactUtils";
export { getUserRole, getLoginEmail } from "./UserUtils";
export { sortByCompanyAndName } from "./SortUtils";

export const getDisplayName = (contact) => {
    if (!contact) {
        return "";
    }

    let displayName = "";
    if (contact.displayName != null) {
        displayName = contact.displayName;
    } else {
        const firstName = contact.firstName ? contact.firstName : "";
        const lastName = contact.lastName ? contact.lastName : "";
        displayName = firstName + " " + lastName;
    }
    return displayName;
}

export const getJobTitle = (contact) => {
    if (!contact) {
        return "";
    }

    return contact.jobTitle;
}

export const getCompanyName = (contact) => {
    if (!contact) {
        return "";
    }

    return contact.companyName;
}

export const getCreatedDate = (contact) => {
    if (!contact) {
        return "";
    }

    return contact.creationDate;
}

export const getDeveloperSince = (contact) => {
    if (!contact || !contact.developer) {
        return "";
    }

    return contact.developer?.accountCreationDate || contact.developer.account.lastUpdateDate;
}

const textAvatarColor = [
    "#ff4900",
    "#d38700",
    "#348833",
    "#007356",
    "#00b2a9",
    "#00b0e5",
    "#0085ca",
    "#6639b7",
    "#91278a",
    "#cf0072",
    "#a50034",
    "#d20000"
];

export function computeCompleteDisplayName(firstName, lastName) {
    let displayName = "";
    let initials = "";
    let color = "";

    if (lastName?.length > 0 && firstName?.length > 0) {
        if (lastName.length !== 1 && firstName.length !== 2) {
            displayName = firstName + " " + lastName;
            initials = firstName.charAt(0) + lastName.charAt(0);
        } else {
            displayName = firstName + " " + lastName;
            initials = firstName.charAt(0) + firstName.charAt(1);
        }
    }

    // Compute contact color
    let upperCaseDisplayName = displayName.toUpperCase();
    let sum = 0;

    for (let idx = 0; idx < upperCaseDisplayName.length; idx += 1) {
        sum += upperCaseDisplayName.charCodeAt(idx);
    }

    let colorIndex = sum % textAvatarColor.length;
    color = textAvatarColor[colorIndex];

    return {
        displayName,
        initials,
        color
    };
}

export const getAvatar = (contact) => {
    if (contact == null || contact.firstName == null || contact.lastName == null) {
        return DEFAULT_AVATAR_URL;
    } else if (contact.avatar) {
        return contact.avatar;
    } else {
        let { initials, color } = computeCompleteDisplayName(contact.firstName, contact.lastName);
        initials = initials.toUpperCase();

        let canvas = document.createElement("canvas");
        canvas.width = 120;
        canvas.height = 120;
        const ctx = canvas.getContext("2d");
        ctx.rect(0, 0, canvas.width, canvas.height);
        ctx.fillStyle = color;
        ctx.fill();
        ctx.font = "bold 50px Helvetica";
        ctx.fillStyle = "white";
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        const verticalOffset = ctx.measureText(initials).actualBoundingBoxDescent / 2;
        ctx.fillText(initials, canvas.width / 2, (canvas.height + verticalOffset) / 2);

        return canvas.toDataURL("image/png");
    }
}

export const getContactByJid = (jid, contactList) => {
    let foundContact = null

    let foundIndex = contactList?.findIndex(contact => contact.jid_im === jid);
    if (foundIndex >= 0) {
        foundContact = contactList[foundIndex];
    }

    return foundContact;
}

export const getContactById = (id, contactList) => {
    let foundContact = null;

    let foundIndex = contactList?.findIndex(contact => contact?.id === id);
    if (foundIndex >= 0) {
        foundContact = contactList[foundIndex];
    }

    return foundContact;
};

export function isInDefaultCompany(user) {
    if (user && user.isInDefaultCompany)
        return user.isInDefaultCompany === true;
    return false;
}